import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { axiosGetV3, axiosPutV3 } from '../../api/axios-handler';

export interface CommsPreferencesResponse {
  comms_preferences: CommsPreference[];
}

export interface CommsPreference {
  description: string;
  id: string;
  name: string;
  subscribed: boolean;
}

const getHubspotCommsPreferences = async (userId: number): Promise<CommsPreferencesResponse> => {
  return axiosGetV3(`/users/${userId}/comms_preferences`, {}).then((res) => res.data);
};

export const useHubspotCommsPreferences = (userId: number) => {
  const { data, isLoading, isFetching, error, refetch } = useQuery<CommsPreferencesResponse>({
    queryKey: ['hubspotCommsPreferences', userId],
    queryFn: () => getHubspotCommsPreferences(userId),
  });
  return { data, isLoading, isFetching, error, refetch };
};

const updateHubspotCommsPreferencesRequest = async (userId: number, commsPreferences: CommsPreferencesResponse) => {
  return axiosPutV3(`/users/${userId}/comms_preferences`, { comms_preferences: commsPreferences.comms_preferences });
};

export const useUpdateHubspotCommsPreferences = (userId: number) => {
  const queryClient = useQueryClient();
  const updateHubspotCommsPreferences = useMutation({
    mutationFn: (commsPreferences: CommsPreferencesResponse) =>
      updateHubspotCommsPreferencesRequest(userId, commsPreferences),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['hubspotCommsPreferences', userId] });
    },
  });
  return { updateHubspotCommsPreferences };
};
